import Nav from './Nav'

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Nav />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">{ children }</main>
    </div>
  )
}
